import React, { useState } from 'react';
import { productosService } from '../../services/productosService';
import { formatCurrency } from '../../utils/formatters';
import { useAuth } from '../../hooks/useAuth';
import '../../styles/components.css';

const VentaForm = ({ venta = null, onSubmit, onCancel, loading = false }) => {
  const { user } = useAuth();
  
  const [detalles, setDetalles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [errors, setErrors] = useState({});

  const handleSearch = async (term) => {
    setSearchTerm(term);
    if (term.length < 2) {
      setSearchResults([]);
      return;
    }

    try {
      const data = await productosService.searchProductos(term);
      setSearchResults(data.results || data);
    } catch (err) {
      console.error('Error al buscar productos:', err);
    }
  };

  const handleAddProducto = (producto) => {
    const existe = detalles.find(d => d.producto_id === producto.id);
    
    if (existe) {
      alert('Este producto ya está en la venta');
      return;
    }

    const precio = producto.precio_venta || producto.precio || 0;

    setDetalles([...detalles, {
      producto_id: producto.id,
      producto_nombre: producto.nombre,
      precio_unitario: precio,
      cantidad: 1,
      subtotal: precio
    }]);

    setSearchTerm('');
    setSearchResults([]);
  };

  const handleCantidadChange = (index, cantidad) => {
    const newDetalles = [...detalles];
    newDetalles[index].cantidad = parseInt(cantidad) || 0;
    newDetalles[index].subtotal = newDetalles[index].precio_unitario * newDetalles[index].cantidad;
    setDetalles(newDetalles);
  };

  const handleRemoveDetalle = (index) => {
    setDetalles(detalles.filter((_, i) => i !== index));
  };

  const calcularTotal = () => {
    return detalles.reduce((sum, detalle) => sum + detalle.subtotal, 0);
  };

  const validate = () => {
    const newErrors = {};

    if (detalles.length === 0) {
      newErrors.detalles = 'Debe agregar al menos un producto';
    }

    const hasInvalidQuantity = detalles.some(d => d.cantidad <= 0);
    if (hasInvalidQuantity) {
      newErrors.detalles = 'Todas las cantidades deben ser mayores a 0';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }

    // Formato correcto para el backend Django
    const dataToSubmit = {
      farmacia: user.farmacia_id || 1,
      items: detalles.map(d => ({
        producto: d.producto_id,
        cantidad: d.cantidad,
        precio_unitario: d.precio_unitario
      }))
    };

    onSubmit(dataToSubmit);
  };

  return (
    <form onSubmit={handleSubmit} className="venta-form">
      <div className="productos-section">
        <h3 className="section-title">Productos</h3>
        
        <div className="producto-search">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar producto por nombre o código..."
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            disabled={loading}
          />
          
          {searchResults.length > 0 && (
            <div className="search-results">
              {searchResults.map(producto => (
                <div
                  key={producto.id}
                  className="search-result-item"
                  onClick={() => handleAddProducto(producto)}
                >
                  <div className="result-info">
                    <strong>{producto.nombre}</strong>
                    <span className="result-code">{producto.codigo}</span>
                  </div>
                  <div className="result-price">{formatCurrency(producto.precio_venta || producto.precio || 0)}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        {errors.detalles && <div className="invalid-feedback" style={{ display: 'block', marginTop: '10px' }}>{errors.detalles}</div>}

        <div className="detalles-list">
          {detalles.length === 0 ? (
            <div className="empty-detalles">
              <p>No hay productos agregados. Busca y selecciona productos para agregar a la venta.</p>
            </div>
          ) : (
            <table className="detalles-table">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Precio Unit.</th>
                  <th>Cantidad</th>
                  <th>Subtotal</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {detalles.map((detalle, index) => (
                  <tr key={index}>
                    <td>{detalle.producto_nombre}</td>
                    <td>{formatCurrency(detalle.precio_unitario)}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control cantidad-input"
                        value={detalle.cantidad}
                        onChange={(e) => handleCantidadChange(index, e.target.value)}
                        min="1"
                        disabled={loading}
                      />
                    </td>
                    <td><strong>{formatCurrency(detalle.subtotal)}</strong></td>
                    <td>
                      <button
                        type="button"
                        className="btn-action btn-delete"
                        onClick={() => handleRemoveDetalle(index)}
                        disabled={loading}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td colSpan="3"><strong>TOTAL</strong></td>
                  <td colSpan="2"><strong className="total-amount">{formatCurrency(calcularTotal())}</strong></td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading || detalles.length === 0}
        >
          {loading ? 'Procesando...' : 'Registrar Venta'}
        </button>
      </div>
    </form>
  );
};

export default VentaForm;

// Made with Bob
